import '@refinitiv-ui/elements/button';
import '@refinitiv-ui/elements/layout';
import '@refinitiv-ui/elements/text-field';
import type { TextField } from '@refinitiv-ui/elements/text-field';
import { CSSResult, LitElement, css, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';

@customElement('user-id-prompt')
export class UserIdPrompt extends LitElement {
  @state()
  _userId = '';

  onInput(event: Event) {
    this._userId = (event.target as TextField).value;
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.onContinue();
    }
  }

  onContinue() {
    const userId = this._userId.trim();
    if (!userId) {
      return;
    }

    this.dispatchEvent(
      new CustomEvent<string>('user-id-submit', {
        detail: userId,
        bubbles: true,
        composed: true,
      })
    );
  }

  onSubmit(event: SubmitEvent) {
    event.preventDefault();
    this.onContinue();
  }

  render() {
    return html`<form @submit=${this.onSubmit}>
      <ef-layout class="field">
        <label for="user-id">User ID</label>
        <ef-text-field
          id="user-id"
          name="username"
          placeholder="Enter User ID"
          icon="profile"
          aria-required="true"
          autofocus
          .value=${this._userId}
          @value-changed=${this.onInput}
          @keydown=${this.onKeyDown}
        ></ef-text-field>
      </ef-layout>
      <ef-layout flex class="actions">
        <ef-button
          type="submit"
          ?disabled=${!this._userId.trim()}
          @click=${this.onContinue}
          >Next</ef-button
        >
      </ef-layout>
    </form>`;
  }

  static get styles(): CSSResult {
    return css`
      :host {
        display: block;
        color: #242424;
        text-align: left;
      }

      form {
        display: grid;
        gap: 42px;
      }

      .field {
        display: grid;
        gap: 5px;
      }

      label {
        font-size: 13px;
        font-weight: 700;
      }

      ef-text-field {
        width: 100%;
        height: 35px;
        font-size: 13px;
      }

      ef-text-field::part(icon) {
        width: 16px;
        height: 16px;
      }

      .actions {
        display: flex;
        justify-content: flex-end;
      }

      ef-button {
        min-width: 60px;
        height: 30px;
        font-size: 13px;
        font-weight: 700;
        text-transform: uppercase;
      }
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'user-id-prompt': UserIdPrompt;
  }
}
